package org.teddapp.project.sync

/**
 * Abstraction du backend distant (Supabase en prod, faux store en tests).
 * Le moteur ne connaît rien de PostgREST ni d'authentification — il pousse des lignes
 * et tire des lignes, point.
 *
 * Contrat :
 *  - `pull(entity, since)` retourne TOUTES les lignes dont `updatedAt > since`,
 *    triées par `updatedAt` ascendant. Inclut les tombstones (`isDeleted = true`).
 *  - `push(entity, rows)` upsert les lignes côté distant. Idempotent — re-pousser
 *    la même ligne deux fois est sans effet. Peut throw en cas d'erreur réseau ;
 *    dans ce cas aucune des lignes du lot n'est considérée comme push réussie.
 */
interface RemoteStore {
    suspend fun pull(entity: EntityKind, since: Long): List<RemoteRow>
    suspend fun push(entity: EntityKind, rows: List<RemoteRow>)

    /** Nombre de lignes de la table côté distant, ou null si le distant ne sait pas compter. */
    suspend fun count(entity: EntityKind): Long? = null

    /** Taille d'une page de réception, ou null si le distant rend tout d'un coup. */
    val pullPageSize: Int? get() = null

    /**
     * Pour un distant à curseur unique : tout ce qui a changé après [since], toutes
     * entités confondues, et le curseur atteint. Null si le distant tire table par table.
     */
    suspend fun pullAll(since: Long): GlobalPull? = null
}

/** Résultat d'un tirage global : les lignes par entité, et le curseur à retenir une fois appliquées. */
class GlobalPull(val rows: Map<EntityKind, List<RemoteRow>>, val cursor: Long)
